import { Box } from '@mui/material';
import useWidth from '../../components/Hooks/useWidth';
import { HighlightsTestIds } from '../../utils/testIds/Highlights.testIds';
import HighlightModal from './HighlightModal';
import HighlightButton from './components/HighlightButton';
import { useHighlights } from './hooks/useHighlights';

const Highlights = () => {
  const { smallWidth } = useWidth();
  const { highlights, openedHighlight, isHighlightOpen, isRead, openHighlight, closeHighlight } =
    useHighlights();

  if (smallWidth || !highlights.length) {
    return null;
  }

  return (
    <>
      <Box
        test-id={HighlightsTestIds.HIGHLIGHTS}
        sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: '1 1 auto', minWidth: 0 }}
      >
        {highlights.map((highlight) => (
          <Box key={highlight.id} sx={{ flex: '0 1 auto', minWidth: 0 }}>
            <HighlightButton
              title={highlight.title}
              isRead={isRead(highlight.id)}
              testId={`${HighlightsTestIds.HIGHLIGHT_BUTTON_PREFIX}${highlight.id}`}
              onClick={() => openHighlight(highlight)}
            />
          </Box>
        ))}
      </Box>

      <HighlightModal
        isOpen={isHighlightOpen}
        highlight={openedHighlight}
        onClose={closeHighlight}
      />
    </>
  );
};

export default Highlights;
